import { default as _91id_93CUaFCHTgO7Meta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue?macro=true";
import { default as accountscGF8R6kLtAMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue?macro=true";
import { default as analyticsmkER82Jx1DMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue?macro=true";
import { default as contactsn5A1sdDpjdMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/contacts.vue?macro=true";
import { default as mailboxesV8sOr3OjGvMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/mailboxes.vue?macro=true";
import { default as newzY6nPD5LaSMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue?macro=true";
import { default as scheduleqfP0en8clUMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/schedule.vue?macro=true";
import { default as steps9uBjl4h4a9Meta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/steps.vue?macro=true";
import { default as outreachz3eBz3ixZIMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue?macro=true";
import { default as setupAHzRVUMr2rMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue?macro=true";
import { default as _91icp_93CsV1ySLMLZMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue?macro=true";
import { default as indexWVMRNtBcFMMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue?macro=true";
import { default as campaignsNkNFuKpZarMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue?macro=true";
import { default as discover8iREzl69KoMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue?macro=true";
import { default as indexaBPqbmBzifMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue?macro=true";
import { default as opensBu2Oi6Dk9gMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue?macro=true";
import { default as repliesU2F5Y8CBXYMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue?macro=true";
import { default as _91listId_93uUTyr038zfMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue?macro=true";
import { default as allQmSNC8vfzvMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue?macro=true";
import { default as mineWeVA8r5F74Meta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue?macro=true";
import { default as sequencesHdjLR1t0yKMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue?macro=true";
import { default as accountRdUlw1u3IQMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue?macro=true";
import { default as crmDF6OJsok3IMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue?macro=true";
import { default as engaged_45accountsK7hs2TulYQMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue?macro=true";
import { default as engaged_45contacts9VFMSadzzNMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue?macro=true";
import { default as exportsQt2AiRHu2IMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue?macro=true";
import { default as forbidden_45accountsWwKGsbYn4IMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue?macro=true";
import { default as forbidden_45contactsC3hyxQ0LUiMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue?macro=true";
import { default as importsHFH1IIJXfxMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue?macro=true";
import { default as indexJXpgDSgmZDMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsoMZhrpshkBMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue?macro=true";
import { default as mailboxVT9vrSQ6A0Meta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue?macro=true";
import { default as notificationsLMvKqChnIeMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue?macro=true";
import { default as organizationgTZU0ix0Q6Meta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue?macro=true";
import { default as repliesvpovGCtgDFMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue?macro=true";
import { default as settingsU1tonBWWOoMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue?macro=true";
import { default as advanced_45icpvANabvxihTMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue?macro=true";
import { default as advanced1pNhWl9O4bMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue?macro=true";
import { default as employeesRZtqzIVtvRMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue?macro=true";
import { default as job_45openingsk7Jq6EVe8LMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue?macro=true";
import { default as newsu4K7pxTAi9Meta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue?macro=true";
import { default as websitesOTS2h6o5kRMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue?macro=true";
import { default as signin1rNEhBkJ9bMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue?macro=true";
import { default as signupzIJJtBDnJjMeta } from "/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue?macro=true";
export default [
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue")
  },
  {
    name: campaignsNkNFuKpZarMeta?.name,
    path: "/campaigns",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue"),
    children: [
  {
    name: "campaigns-icp",
    path: ":icp()",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-accounts",
    path: "accounts",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue")
  },
  {
    name: "campaigns-icp-analytics",
    path: "analytics",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue")
  },
  {
    name: "campaigns-icp-outreach",
    path: "outreach",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue"),
    children: [
  {
    name: "campaigns-icp-outreach-contacts",
    path: "contacts",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/contacts.vue")
  },
  {
    name: "campaigns-icp-outreach-mailboxes",
    path: "mailboxes",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/mailboxes.vue")
  },
  {
    name: "campaigns-icp-outreach-new",
    path: "new",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue")
  },
  {
    name: "campaigns-icp-outreach-schedule",
    path: "schedule",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/schedule.vue")
  },
  {
    name: "campaigns-icp-outreach-steps",
    path: "steps",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/steps.vue")
  }
]
  },
  {
    name: "campaigns-icp-setup",
    path: "setup",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue")
  }
]
  },
  {
    name: "campaigns",
    path: "",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue")
  }
]
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue")
  },
  {
    name: "sequences",
    path: "/sequences",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue")
  },
  {
    name: settingsU1tonBWWOoMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue")
  },
  {
    name: "settings-crm",
    path: "crm",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue")
  },
  {
    name: "settings-engaged-accounts",
    path: "engaged-accounts",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue")
  }
]
  },
  {
    name: "signals-advanced-icp",
    path: "/signals/advanced-icp",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue")
  },
  {
    name: "signals-advanced",
    path: "/signals/advanced",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue")
  },
  {
    name: "signals-employees",
    path: "/signals/employees",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue")
  },
  {
    name: "signals-job-openings",
    path: "/signals/job-openings",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue")
  },
  {
    name: "signals-news",
    path: "/signals/news",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue")
  },
  {
    name: "signals-websites",
    path: "/signals/websites",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src3966890131/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue")
  }
]